import {list} from '../../../../domain/processos/services/comarca'
import window from './window/windowComarca'

export default {
  pageTitle: 'Comarcas',
  columns: [
    {
      name: 'id',
      required: true,
      label: 'ID',
      align: 'left',
      field: 'id',
      sortable: true,
      parser: function (props) {
        return props.id
      }
    },
    {
      name: 'codigo',
      required: true,
      label: 'Código',
      align: 'left',
      field: 'codigo',
      sortable: true,
      parser: function (props) {
        return props.codigo
      }
    },
    {
      name: 'nome',
      required: true,
      label: 'Comarca',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'uf',
      required: true,
      label: 'UF',
      align: 'left',
      field: 'uf',
      sortable: true,
      parser: function (props) {
        return props.uf
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: list,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this)
    }
  }
}
